import React from "react";
import { useScrollLock } from "usehooks-ts";

const NavScreenLocker = () => {
  useScrollLock({ widthReflow: false });

  return (
    <div className="z-[3] hidden h-full w-full bg-black opacity-50 md:fixed md:block lg:invisible" />
  );
};

export default NavScreenLocker;
